unit FunctionItemType;
{

/* Initial. */

}

interface

type
  TFunctionItemType = class
  private
    fFunctionKey: String;
    fName: String;
    fActive: Boolean;
  public
    property FunctionKey: String read fFunctionKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
  end;

implementation

end.
